import io from "socket.io-client";
import { toast } from "react-toastify";
import React from "react";

import { store } from "./get-redux-store";
import OrderInvite from "../components/_common/order-invite";
import OrderInviteChanged from "../components/_common/order-invite-changed";

export let socket;

let customerCallback = null;

let currentInviteId = -1;
export const setupSocket = () => {
  socket = io(`${process.env.REACT_APP_SOCKET_BASE_URL}`, {
    transports: ["websocket"]
  });

  socket.on("connect", function () {
    const { authenticated, profile } = store.getState().auth;
    if (authenticated === true) {
      registerCustomerChannel(profile.customer.id);
    }
  });

  socket.on("customer", data => {
    const { inviteId } = data.message;
    if (data.name === "order-invite") {
      if (currentInviteId !== inviteId) {
        currentInviteId = inviteId;
        toast(<OrderInvite message={data.message} />, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: false,
          removeCloseButton: true
        });
      }
    } else if (data.name === "host-order-changed") {
      if (currentInviteId !== inviteId) {
        currentInviteId = inviteId;
        toast(<OrderInviteChanged message={data.message} />, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: true,
          removeCloseButton: false
        });
      }
    } else {
      toast.info(data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }

    if (customerCallback !== undefined) {
      customerCallback(data.scope);
    }
  });
};

export const registerCustomerChannel = (customerId, callback) => {
  socket.emit("unregister", { id: customerId, type: "customer" }, () => {
    socket.emit("register", { id: customerId, type: "customer" }, confirmed => {
      customerCallback = callback;
    });
  });
};

export const unregisterCustomerChannel = customerId => {
  socket.emit("unregister", { id: customerId, type: "customer" }, confirmed => {
    console.log(confirmed);
  });
};

export const registerOrderChannel = (orderId, callback) => {
  socket.off("order");
  socket.emit("register", { id: orderId, type: "order" }, confirmed => {
    console.log(confirmed);
  });

  socket.on("order", data => {
    if (data.scope === "order") {
      callback(data.name);
    }
  });
};

export const unregisterOrderChannel = orderId => {
  socket.emit("unregister", { id: orderId, type: "order" }, confirmed => {
    console.log(confirmed);
  });
};
